"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _classnames = _interopRequireDefault(require("classnames"));

var _sharedCss = _interopRequireDefault(require("../../shared/oldDocumentSignerUI/sharedCss"));

var _fieldStatusClass = _interopRequireDefault(require("./fieldStatusClass"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var styles = _objectSpread({}, _sharedCss.default.fields, {
  dropdown: {
    position: 'absolute'
  }
});

var Dropdown = function Dropdown(props) {
  var id = props.id,
      name = props.name,
      x = props.x,
      y = props.y,
      height = props.height,
      width = props.width,
      handleChange = props.handleChange,
      classes = props.classes,
      options = props.options,
      setFieldRef = props.setFieldRef,
      _props$value = props.value,
      value = _props$value === void 0 ? '' : _props$value,
      _props$_derived = props._derived,
      isRequired = _props$_derived.isRequired,
      isDisabled = _props$_derived.isDisabled;
  var fieldDynamicStyle = {
    top: y,
    left: x,
    height: height,
    width: width
  };
  var dropdownOptions = Object.keys(options).map(function (optionValue) {
    return _react.default.createElement(_core.MenuItem, {
      key: "".concat(name, "-").concat(options[optionValue]),
      value: optionValue,
      "data-test-id": "Dropdown-option-".concat(id, "/").concat(optionValue),
      dense: true
    }, options[optionValue]);
  });
  dropdownOptions.unshift(_react.default.createElement(_core.MenuItem, {
    key: "Dropdown-defaultNone-".concat(name),
    value: "",
    "data-test-id": "Dropdown-defaultNone-".concat(name),
    dense: true
  }, "None"));
  return _react.default.createElement(_core.Select, {
    disableUnderline: true,
    inputRef: function inputRef(e) {
      return setFieldRef(e, y);
    },
    placeholder: isRequired ? 'Required' : '',
    id: name,
    value: value,
    className: (0, _classnames.default)(classes.dropdown, (0, _fieldStatusClass.default)(props)),
    style: fieldDynamicStyle,
    onChange: function onChange(e) {
      return handleChange(e.target.value);
    },
    "data-test-id": "Dropdown-root-".concat(id),
    disabled: isDisabled
  }, dropdownOptions);
};

Dropdown.propTypes = {
  name: _propTypes.default.string.isRequired,
  x: _propTypes.default.number.isRequired,
  y: _propTypes.default.number.isRequired,
  height: _propTypes.default.number.isRequired,
  width: _propTypes.default.number.isRequired,
  handleChange: _propTypes.default.func.isRequired,
  classes: _propTypes.default.object.isRequired,
  options: _propTypes.default.object.isRequired,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};

var _default = (0, _styles.withStyles)(styles)(Dropdown);

exports.default = _default;